import { render, staticRenderFns } from "./KeyWord.vue?vue&type=template&id=49e47f57&scoped=true"
import script from "./KeyWord.vue?vue&type=script&lang=js"
export * from "./KeyWord.vue?vue&type=script&lang=js"
import style0 from "./KeyWord.vue?vue&type=style&index=0&id=49e47f57&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e47f57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49e47f57')) {
      api.createRecord('49e47f57', component.options)
    } else {
      api.reload('49e47f57', component.options)
    }
    module.hot.accept("./KeyWord.vue?vue&type=template&id=49e47f57&scoped=true", function () {
      api.rerender('49e47f57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/KeyWord.vue"
export default component.exports